module.exports = __webpack_public_path__ + "static/reva.ec7c38a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/reva.jpg
// module id = 483
// module chunks = 43369700788870